import { useBrandConfig } from "@/hooks/use-brand-config";
import tloLogoDark from "@/assets/tlo-logo-dark.png.asset.json";
import tloLogoLight from "@/assets/tlo-logo-light.png.asset.json";

interface BrandLogoProps {
  className?: string;
  variant?: "default" | "light";
}

const BrandLogo = ({ className = "", variant = "default" }: BrandLogoProps) => {
  const { brandName, logoUrl } = useBrandConfig();

  // Split by spaces or by camelCase capital letters
  const parts = brandName.includes(" ")
    ? brandName.split(" ")
    : brandName.split(/(?=[A-Z])/).filter(Boolean);

  const textColor = variant === "light" ? "text-white" : "text-foreground";
  const initial = brandName.charAt(0);

  // Default brand uses the full Top Loan Offers lockup
  const isDefaultBrand = !logoUrl && brandName.replace(/\s+/g, "").toLowerCase() === "toploanoffers";

  if (isDefaultBrand) {
    return (
      <img
        src={variant === "light" ? tloLogoLight.url : tloLogoDark.url}
        alt={brandName}
        className={`h-[64px] md:h-[76px] w-auto object-contain ${className}`}
      />
    );
  }

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {logoUrl ? (
        <img src={logoUrl} alt={brandName} className="h-8 w-8 object-contain rounded" />
      ) : (
        <div className="w-10 h-10 rounded-lg gradient-cta flex items-center justify-center">
          <span className="text-primary-foreground font-bold text-lg">{initial}</span>
        </div>
      )}
      <span className={`font-bold text-lg ${textColor} leading-tight`}>
        {parts.map((word, i) => (
          <span key={i}>
            {i > 0 && " "}
            <span className={i === 1 ? (variant === "light" ? "text-accent" : "text-primary") : ""}>{word}</span>
          </span>
        ))}
      </span>
    </div>
  );
};

export default BrandLogo;
